<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="类路径"
              hasFeedback
            >
              <a-input
                placeholder="请输入类路径"
                id="clazz"
                :disabled="!isEdit"
                v-decorator="['clazz', { rules: [{ required: true, message: '请输入类路径！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="占位符"
              hasFeedback
            >
              <a-input
                placeholder="请输入占位符"
                id="code"
                :disabled="!isEdit"
                v-decorator="['code', { rules: [{ required: true, message: '请输入占位符！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="方法名"
              hasFeedback
            >
              <a-input
                placeholder="请输入方法名"
                id="method"
                :disabled="!isEdit"
                v-decorator="['method', { rules: [{ required: true, message: '请输入方法名！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="优先级"
              hasFeedback
            >
              <a-input
                placeholder="请输入优先级"
                id="priority"
                :disabled="!isEdit"
                v-decorator="['priority', { rules: [{ required: true, message: '请输入优先级！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="替换规则"
              hasFeedback
            >
              <a-input
                placeholder="请输入替换规则"
                id="sentence"
                :disabled="!isEdit"
                v-decorator="['sentence', { rules: [{ required: true, message: '请输入替换规则！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="占位符类型"
              hasFeedback
            >
              <a-select
                :allowClear="true"
                mode="multiple"
                placeholder="请选择占位符类型"
                @change="handleChange"
                :disabled="!isEdit"
                v-decorator="['type', { rules: [{ required: true, message: '请选择占位符类型！' }] }]"
              >
                <a-select-option v-for="(item,index) in typeList" :key="index" >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="值"
              hasFeedback
            >
              <a-input
                placeholder="请输入值"
                id="value"
                :disabled="!isEdit"
                v-decorator="['value', { rules: [{ required: true, message: '请输入值！' }] }]"/>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
              <a-button type="primary" html-type="submit" style="margin-right:10px;">
                提交
              </a-button>
              <a-button style="margin-right:10px;" @click="cancel">
                取消
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'

import { getPlaceholderInfo, insertPlaceholder, updatePlaceholder } from '@/api/placeholder'

export default {
  name: 'EditPlaceholder',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 600,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'placeholder' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      typeList: [
        {
          label: '常量',
          value: 1
        },
        {
          label: '工具类方法',
          value: 2
        }]
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if (flag) {
          this.getModelInfo(this.model)
        }
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          if (this.type === this.$sysInfo.MODAL_ADD) {
            insertPlaceholder(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            updatePlaceholder(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      this.infoLoading = true
      getPlaceholderInfo().then(res => {
        if (res.status === 0) {
          this.form.setFieldsValue({
            clazz: this.model.clazz,
            code: this.model.code,
            method: this.model.method,
            priority: this.model.priority,
            sentence: this.model.sentence,
            type: this.model.type,
            value: this.model.value
          })
          this.infoLoading = false
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    handleChange () {

    },
    // 清空表单
    formClear () {
      this.form.setFieldsValue({ clazz: '', code: '', method: '', priority: '', sentence: '', type: [], value: '' })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }

  }
}
</script>

<style scoped>

</style>
